import { afterNextRender, ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DelayedScriptsComponent } from '@components/delayed-scripts';
import { FooterComponent } from '@components/footer';
import { HeaderComponent } from '@components/header';
import { environment } from '@environments/environment';
import { VARIABLES } from '@environments/environment.variables';
import { HeadScriptLoaderService } from '@shared/services/head-script-loader';
import { LogsService } from '@shared/services/logs';
import { LogLevel } from '@shared/services/logs/enums';
import { SeoService } from '@shared/services/seo';
import { PageStore } from '@stores';
import { format } from 'date-fns';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, DelayedScriptsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  pageType = inject(PageStore).select('type');
  private readonly seoService = inject(SeoService);
  private readonly headScriptLoaderService = inject(HeadScriptLoaderService);
  private readonly logs = inject(LogsService);

  constructor() {
    afterNextRender(() => {
      const requestMetricsToken = environment.integrations?.requestMetrics?.apiKey;
      if (requestMetricsToken) {
        this.seoService.setLinkTag('dns-prefetch', 'https://cdn.requestmetrics.com');
        this.headScriptLoaderService.injectScript({
          id: 'request-metrics-loader',
          src: 'scripts/rum-request-metrics.js',
          async: true,
          type: 'text/javascript',
          'data-token': requestMetricsToken,
        });
        this.logs.info('AppComponent', 'Request metrics script injected');
      }
      const buildDate = VARIABLES.buildTimestamp
        ? format(new Date(VARIABLES.buildTimestamp), 'dd/MM/yyyy HH:mm')
        : 'local';
      const version = VARIABLES.version || 'dev';
      const showCommit = environment.logLevel >= LogLevel.DEBUG && VARIABLES.commitHash;
      const commitSegment = showCommit ? ` · ${VARIABLES.commitHash}` : '';
      // eslint-disable-next-line no-console -- intentional: surfaced to every user (incl. prod) for support purposes
      console.log(`🏷️ Build : ${version}${commitSegment} · ${buildDate}`);
      this.logs.trace('AppComponent', 'environment', environment);
    });
  }
}
